<div class="flex-content">
  <div class="make_dimmer"></div>
  <div class="content col-sm container-fluid">
    <div class="row start-row no-gutters">

      <h2 class="about-title text-center">Working with Visual Media Lab</h2>
      <br>
      <p class="text-center">We are looking for... </p>

      <div class="member_image_box col-sm-12">
        <!-- card container-->
        <div class="partner-box col-sm-12 col-md-6 col-lg-3">
          <div class="partner-img text-center"><img [src]='relPath + "about_admission_01_StudentResearchers.png"'></div>
          <div class="partner-text text-center">
            <h3>Student Researchers</h3>
            <p>Talented and motivated students interested in the field of computer graphics.</p>
          </div>
          </div>
        <!-- card container-->
        <div class="partner-box col-sm-12 col-md-6 col-lg-3">
          <div class="partner-img"><img [src]="relPath + 'about_admission_02_PostdocResearchers.png'"></div>
          <div class="partner-text text-center">
            <h3>Postdoc Researchers</h3>
            <p>Highly motivated postdoc researchers in the area of character animation, fluid simulation or computer vision.</p>
          </div>
        </div>
        <!-- card container-->
        <div class="partner-box col-sm-12 col-md-6 col-lg-3">
          <div class="partner-img"><img [src]=" relPath + 'about_admission_03_CGProgrammers.png'" alt="Partner Company Img"/></div>
          <div class="partner-text text-center">
            <h3>CG Programmers</h3>
            <p> Talented and enthusiastic CG programmers to support our VFX, Animation production and CG research.</p>
          </div>
        </div>
        <!-- card container-->
        <div class="partner-box col-sm-12 col-md-6 col-lg-3">
          <div class="partner-img"><img [src]=" relPath + 'about_admission_04_CGArtist.png'" alt="Partner Company Img"/></div>
          <div class="partner-text text-center">
            <h3>CG Artist</h3>
            <p>Talented, motivated, and experienced CG artists to join its production team. Should have experience in modeling, rendering or effects.</p>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="divider"></div>
    <br>
    <div class="row start-row no-gutters">
      <h2 class="about-title text-center">Internship Opportunities at Visual Media Lab</h2>
      <br>
      <br>
      <p class="text-left"> We are hiring undergraduate student interns.
        <br>
        Anyone interested in doing an intern at VML is advised to go through <strong>the recent projects/publications</strong> section carefully
        and see if the current lab research directions are aligned with his/her interest.
        <br>
        The instruction to apply for internship is as follows.
        <br>
        <br>
        Please note.
        <br>
        Internship does not guarantee admission to the Master/Ph.D. program.
      </p>
      <br>
      <p class="text-left"><strong>Summer Internship (June-August)</strong>
        <br>
        - Application Period: ~ May 15th
        <br>
        - Interviews: End of May
      </p>
      <br>
      <p class="text-left"><strong>Winter Internship (December-February)</strong>
        <br>
        - Application Period: ~ November 15th
        <br>
        - Interviews: End of November
      </p>
      <br>
      <p class="text-left"><strong>Application Requirement:</strong>
        <br>
        - CV, Transcript(optional)
      </p>
      <br>
      <p class="text-left"><strong>Preferred Qualifications:</strong>
        <br>
        - Experience in PyTorch
        <br>
        - Computer graphics/vision
        <br>
        - 3D modeling/animation
      </p>
      <br>
      <p class="text-left"><strong>How to Apply:</strong>
        <br>
        Send your application to "<a href="mailto:visualmedia@kaist.ac.kr">visualmedia@kaist.ac.kr</a>" with the title "Internship Application – [Your Name]".
      </p>
      <!-- <p class="text-left">Recent breakthroughs in the field of deep learning gives the ability to the computer vision and computer graphics scientist to
        combine available 2D and 3D information to generate realistic videos. KAIST Visual Media Laboratory provides a unique opportunity for diligent and
        enthusiastic master students to participate in high-quality research and state-of-the-art projects related to realistic video synthesis.
        A qualified candidate should have basic knowledge in deep learning as well as strong understanding in computer vision and computer graphics.
        The candidate is also expected to conduct research with minimum supervision.
      </p>
      <br>
      <p class="text-left">Current research projects include deep learning based automatic facial/body animation generation and video generation from a single image. Specifically: </p>
      <p class="text-left">- Generating realistic facial animation</p>
      <p class="text-left">- High level goal driven natural body animation synthesis</p>
      <p class="text-left">- Generating realistic videos from one single static image using available scene information. Creating frame sequences with motions such as facial expressions, body movements, camera work and natural scene flow using a generative network on a single image
      </p> -->
    </div>
    <br>
    <div class="divider"></div>
    <br>
    <div class="row contact-row no-gutters">
      <div class="contact-intro">
        <h2 class="text-center">CONTACT US</h2>
        <p class="text-center">Contact us if you have any questions about VML. <a href="mailto:visualmedia@kaist.ac.kr">visualmedia@kaist.ac.kr</a></p>
        <!-- <p class="text-center">Email us if you have resume to send: </p> -->
        <p class="text-center">For student researchers, you must first apply to KAIST <a href="https://ct.kaist.ac.kr">Graduate School of Culture Technology (GSCT)</a></p>
      </div>
      <!--<form class="contact-form">
        <md-input-container>
          <input mdInput placeholder="Your Name" value="John Doe">
        </md-input-container>
        <md-input-container>
          <input mdInput placeholder="Your Email" value="example@example.com">
        </md-input-container>
        <md-input-container>
          <input mdInput placeholder="Message" value="any message">
        </md-input-container>
        <button md-raised-button type="submit">SUBMIT</button>
      </form>-->
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/about-admission/about-admission.component.html